import { withForm } from "components/Forms/AppForm";

import { defaultProficiencyFeedbackValues } from "../../../ProficiencyFeedbackForm.default";

const CommentsFormText = withForm({
  defaultValues: defaultProficiencyFeedbackValues,
  props: { readonly: false },
  render: ({ form, readonly }) => {
    return (
      <form.AppField name="comments">
        {(field) => <field.HtmlEditor label="" disabled={readonly} />}
      </form.AppField>
    );
  },
});

export default CommentsFormText;
